import { useContext } from 'react';
import { useCookies } from 'react-cookie';
import useSwitchesFromContext from './useSwitchesFromContext';
import CheckoutPageContext from '../context/CheckoutPageContext';
import { store } from '../components/useLog/Logger/Utils/Store/Store';
import { rootLogger } from '../components/useLog/useLog';
import $window from '../tools/window';

export const redirectToOrderConfirmation = (redirectURL) => {
  setTimeout(() => {
    $window.location = redirectURL;
  }, 0);
};

export const redirectToOrderConfirmationIphone = (
  hasIOSMarketingSubscribe,
  isLoggedIn,
  orderId,
  subscriptionValues,
) => {
  const postMessageData = {
    orderId,
  };
  if (hasIOSMarketingSubscribe && !isLoggedIn) {
    postMessageData.subscriptionValues = subscriptionValues;
  }

  $window.webkit.messageHandlers.orderConfirmation.postMessage(
    JSON.stringify(postMessageData),
  );
};

export const redirectToOrderConfirmationAndroid = (
  hasAndroidMarketingSubscribe,
  isLoggedIn,
  orderId,
  subscriptionValues,
) => {
  const postMessageData = {
    orderId,
  };
  if (hasAndroidMarketingSubscribe && !isLoggedIn) {
    postMessageData.subscriptionValues = subscriptionValues;
  }

  // eslint-disable-next-line no-undef
  Android.navigateOrderConfirmation(
    JSON.stringify(postMessageData),
  );
};

export const pushBingUetDataToWindow = (products) => {
  try {
    const { digitalData } = $window;
    const pageKind = digitalData?.get('page.pageKind');
    const pagetype = pageKind === 'shopping cart' ? 'cart' : pageKind;
    $window.uetq = $window?.uetq || [];
    products?.forEach((product) => {
      $window?.uetq?.push({
        prodid: product?.item?.productContent?.shortSku,
        pagetype,
      });
    });
  } catch (err) {
    rootLogger.logger('useOcnRedirection').error(`ERR: pushBingUetDataToWindow: ${JSON.stringify(err)}`).destroy();
  }
};

export const goToOrderConfirmationPage = (pageState, getSwitchValue, cookies, orderData = null) => {
  const debugAppMode = store.localStorage.get('debug_app_mode');

  const hasIOSMarketingSubscribe = getSwitchValue('chkHasIosMarketingSubscribe');
  const hasAndroidMarketingSubscribe = getSwitchValue('chkHasAndroidMarketingSubscribe');

  let nativeOrderConfirmationEnabled;
  let deviceType;
  let orderId;
  let isLoggedIn;
  let redirectURL;
  let products;
  if (orderData) {
    nativeOrderConfirmationEnabled = orderData?.deviceInfo?.isNativeOcnEnabled;
    deviceType = (orderData?.deviceInfo?.deviceType)?.toLowerCase();
    orderId = orderData?.orderId;
    isLoggedIn = orderData?.isLoggedIn;
    redirectURL = orderData?.orderConfirmationURL;
    products = orderData?.bagItems?.items;
  } else {
    const {
      userData, orderTotals, deviceInfo, applePayButton, bagItems,
    } = pageState;
    nativeOrderConfirmationEnabled = deviceInfo?.isNativeOcnEnabled;
    deviceType = (deviceInfo?.deviceType)?.toLowerCase();
    orderId = orderTotals?.orderId;
    isLoggedIn = userData?.isLoggedIn;
    redirectURL = applePayButton?.orderConfirmationURL;
    products = bagItems?.items;
  }

  pushBingUetDataToWindow(products);

  if (debugAppMode
    || ((deviceType === 'iphone' || deviceType === 'android') && nativeOrderConfirmationEnabled)
  ) {
    const subscriptionValues = cookies?.subscribe || {};

    if ((deviceType === 'iphone' && typeof window.webkit !== 'undefined')
      || debugAppMode === 'iphone'
    ) {
      redirectToOrderConfirmationIphone(
        hasIOSMarketingSubscribe,
        isLoggedIn,
        orderId,
        subscriptionValues,
      );
    } else if ((deviceType === 'android' && typeof Android !== 'undefined')
      || debugAppMode === 'android'
    ) {
      redirectToOrderConfirmationAndroid(
        hasAndroidMarketingSubscribe,
        isLoggedIn,
        orderId,
        subscriptionValues,
      );
    } else {
      redirectToOrderConfirmation(redirectURL);
    }
  } else {
    redirectToOrderConfirmation(redirectURL);
  }
};

const useOcnRedirection = () => {
  const { getSwitchValue } = useSwitchesFromContext();
  const context = useContext(CheckoutPageContext);
  const checkoutPageState = context?.checkoutPageState || {};
  const [cookies] = useCookies(['subscribe']);

  return (orderData = null) => {
    goToOrderConfirmationPage(checkoutPageState, getSwitchValue, cookies, orderData);
  };
};

export default useOcnRedirection;
